export default __webpack_public_path__ + "static/media/tr.1a108aef.svg";